var $cd14d567c9726e0d$exports = {};
$cd14d567c9726e0d$exports = {
    "invalidSelection": (args, formatter)=>`Atlas\u{12B}tais(-ie) ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} nav pieejams(-i).`
};


export {$cd14d567c9726e0d$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
